/** `sizes` hints for GatsbyImage — align with ~800px layout breakpoints used across the site. */

export const SHOP_OR_COLLECTION_GRID_SIZES = `(max-width: 800px) 92vw, 48vw`;

export const FULL_VIEWPORT_SIZES = `100vw`;

/** Contact page: portrait thumbnails within a 6-column person row. */
export const CONTACT_PEOPLE_THUMB_SIZES = `(max-width: 1000px) 70vw, 38vw`;

/** Search overlay preview: right column (~3/12) on large screens only (hidden below 900px). */
export const SEARCH_PREVIEW_SIZES = `(max-width: 1350px) 30vw, 26vw`;

/** Fairs slideshow: full-width of content on small screens. */
export const FAIRS_GALLERY_SIZES = `(max-width: 900px) 100vw, min(1100px, 88vw)`;

/** Splash: single hero image in padded container. */
export const SPLASH_SINGLE_IMAGE_SIZES = `(max-width: 800px) 92vw, min(1200px, 94vw)`;

/** Splash: two-image layout — left column (only column visible on mobile). */
export const SPLASH_TWO_IMAGE_LEFT_SIZES = `(max-width: 800px) 92vw, 47vw`;

/**
 * Splash: two-image layout — right column (hidden with CSS below 800px; tiny slot hints
 * smallest src on phones so we avoid a large off-screen download).
 */
export const SPLASH_TWO_IMAGE_RIGHT_SIZES = `(max-width: 800px) 1px, 47vw`;

/**
 * Artists index: decorative floating thumbnail (hidden below 800px — tiny slot avoids
 * mobile loading a large unused asset).
 */
export const ARTISTS_INDEX_CAPTION_SIZES = `(max-width: 800px) 1px, 25vw`;
